<template>
    <div class="container pm10">
        <div class="container__content">
            <div class="container__border"></div>
            <div class="container__title">TSP</div>
            <div class="selector">
                <time-select @currentValue='currentValue'/>
            </div>
        </div>
        <div class="pm10-info">
            <env-charts :pmData="tspData" :pmLimitData="tspLimitData" envName="TSP"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimeSelect from '../time-select'
import EnvCharts from '../env-charts'
export default {
    components: {
        TimeSelect,
        EnvCharts
    },
    props: {
        tspTimeData: {
            type: Object,
            default () {
                return null
            }
        },
        limitMap: {
            type: Object,
            default () {
                return null
            }
        }
    },
    data () {
        return {
            id: '1',
            tspData: [],
            tspLimitData: 0,
            tspCurrenData: {},
        }
    },
    computed: mapGetters(['projectId']),
    watch: {
        limitMap (val) {
            if (val) {
                this.tspLimitData = val.tspHighLimit
            } else {
                this.tspLimitData = ''
            }
        },
        tspTimeData (val) {
            if (val) {
                this.tspCurrenData = val
                if (this.id == '1') {
                    this.tspData = val.tspDayData.rows
                } else {
                    this.tspData = val.tspMonthData.rows
                }
            }
        }
    },
    methods: {
        currentValue (id) {
            this.id = id
            if (this.id == '1') {
                this.tspData = this.tspCurrenData.tspDayData.rows
            } else {
                this.tspData = this.tspCurrenData.tspMonthData.rows
            }
        }
    }
}
</script>

<style lang="less" scoped>
.pm10 {
    height: 307px;
    position: relative;
    .selector{
        position: absolute;
        top: 18px;
        right: 16px;
        z-index: 1000;
    }
    &-info {
        width: 424px;
        height: 228px;
        margin: 7px 16px 16px 16px;
    }
}
</style>